const describePrototypeFields = (error: { message: unknown }) => {
  const type = Object.prototype.toString.call(error).slice('[object '.length, -1)
  const code = 'code' in error && error.code !== undefined ? ` ${String(error.code)}` : ''

  return `${type}${code}: ${String(error.message)}`
}

export const describeNonError = (error: unknown): string => {
  // This runs inside the error handler, and reading an unknown payload can throw: circular refs,
  // BigInt, or a getter that throws
  try {
    const serialized = JSON.stringify(error) ?? String(error)

    if (serialized === '{}' && typeof error === 'object' && error !== null && 'message' in error) {
      return describePrototypeFields(error)
    }

    return serialized
  } catch {
    try {
      return Object.prototype.toString.call(error)
    } catch {
      return 'unreadable value'
    }
  }
}
